module.exports = __webpack_public_path__ + "img/Help.5e3a714b.svg";